;( function ($) {

	/**
	 * @todo check how this triggers on tablets
	 */
	$(document).ready(function () {
		var $pushes = $('.push-section .slick-slider');
		var $banner = $('.page.banner');
		var resizeTimer;

		// @todo add element exists conditionals

		maybeAlterPageHeader( $banner );
		$(window).on('resize', function(e) {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				maybeAlterPageHeader( $banner );
			}, 250);
		});

		initSliders();
		$(window).resize(function () {
			/**
			 * @todo debounce
			 */
			initSliders();
		});


		/**
		 * If a banner is in mobile mode, change background image
		 * and fix aspect ratio
		 *
		 * @param {jQuery} $banner
		 */
		function maybeAlterPageHeader( $banner ) {
			var pageWidth = window.outerWidth;
			var $img  = $banner.find('img');
			var image = $img.data( 'desktop' );
			if ( pageWidth < 660 ) {
				image = $img.data( 'mobile' ) || $img.data( 'desktop' );
			}
			$img.attr( 'src', image );
		}


		/**
		 * Slick the sliders
		 */
		function initSliders() {
			if (window.innerWidth < 1000) {
				_.each($pushes, function (slider) {
					$(slider).slick(
						{
							"slidesToShow": 4,
							"slidesToScroll": 4,
							dots: true,
							infinite: false,
							responsive: [
								{
									breakpoint: 768,
									settings: {
										slidesToShow: 3,
										slidesToScroll: 3
									}
								},
								{
									breakpoint: 600,
									settings: {
										slidesToShow: 2,
										slidesToScroll: 2
									}
								},
								{
									breakpoint: 480,
									settings: {
										slidesToShow: 2,
										slidesToScroll: 2
									}
								}
								// You can unslick at a given breakpoint now by adding:
								// settings: "unslick"
								// instead of a settings object, allegedly
							]
						}
					);
				});
			} else {
				_.each($pushes, function (slider) {
					var $slider = $(slider);
					if( $slider.hasClass( 'slick-initialized' ) ) {
						$(slider).slick('unslick');
					}
				});
			}
		}
	});

}(jQuery));